import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyFormatterUtil } from '../services/currency-formatter-util';

@Pipe({
  name: 'currencyShort'
})
export class CurrencyShortPipe implements PipeTransform {
  /**
   * Transform currency value to abbreviated format
   * @param value - The currency value
   * @param decimalPlaces - Number of decimal places (default: 2)
   * @param locale - Currency locale (default: 'INR')
   * @returns Formatted currency string
   */
  transform(
    value: number | null | undefined,
    decimalPlaces: number = 2,
    locale: string = 'INR'
  ): string {
    return CurrencyFormatterUtil.formatCurrency(value, decimalPlaces, locale);
  }
}